'use client'

import styles from './VebinarSlider.module.scss'
import { Navigation, Pagination } from 'swiper/modules'

import { Swiper, SwiperSlide } from 'swiper/react'

import { useEffect, useState } from 'react'
import VebinarItem from '../../../features/VebinarItem'
import classNames from 'classnames'
import { useMediaQuery } from '@uidotdev/usehooks'
import { useGetVebinarsHomeMutation } from '@/shared/api-rtk/index.js'
import { TOAST_ERROR } from '@/shared/constants/toastTypes.js'

export function VebinarSlider() {
    const isSmallDevice = useMediaQuery('only screen and (max-width : 1240px)')
    const [seminars, setSeminars] = useState(null)
    const [getVabinars] = useGetVebinarsHomeMutation()

    useEffect(() => {
        getVabinars()
            .unwrap()
            .then((res) => {
                if (res.result === 'success') {
                    setSeminars(Object.values(res.data))
                }
            })
            .catch(() => TOAST_ERROR('Ошибка получения вебинаров'))
    }, [])

    if (!seminars) {
        return <h4>Загрузка...</h4>
    }

    return (
        <div>
            <div className={styles.titleContainer}>
                <h2 className={styles.title}>Обучение BTpeeL</h2>
                <p className={classNames(styles.subtitle)}>
                    Телефон, WhatsApp для записи и регистрации +7 (925)
                    766-96-67
                </p>
            </div>
            <Swiper
                modules={[Navigation, Pagination]}
                spaceBetween={20}
                slidesPerView={isSmallDevice ? 1 : 3}
                navigation
                pagination={{ clickable: true }}
                breakpoints={{
                    1800: {
                        spaceBetween: 95,
                    },
                    2250: {
                        spaceBetween: 130,
                    },
                }}
            >
                {seminars?.map((seminar) => {
                    return (
                        <SwiperSlide
                            style={{ paddingBottom: '40px' }}
                            key={seminar.seminar_id}
                        >
                            <VebinarItem item={seminar} />
                        </SwiperSlide>
                    )
                })}
            </Swiper>
        </div>
    )
}
